<template>
  <div>
    <el-popover placement="top-start" title="自定义表头" width="300" trigger="click">
      <el-checkbox
        :indeterminate="isIndeterminate"
        v-model="checkAll"
        @change="handleCheckAllChange"
      >全选</el-checkbox>
      <el-checkbox-group v-model="checkedList" @change="handleCheckedChange">
        <el-checkbox v-for="item in tableLabel" :label="item.param" :key="item.param">{{item.label}}</el-checkbox>
      </el-checkbox-group>
      <el-button slot="reference" icon="el-icon-setting">自定义</el-button>
    </el-popover>
  </div>
</template>
<script>
/**
 * 自定义表头列显隐组件
 * 功能：勾选要展示的列，将选中列存入 localStorage 并通知父组件
 */
export default {
  props: {
    tableLabel: {
      type: Array,
      default: () => {
        return [];
      }
    },
    hiddenString: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      checkAll: false,
      checkedList: [],
      isIndeterminate: true
    };
  },
  created() {
    this.dataAnalysis();
  },
  methods: {
    dataAnalysis() {
      //选中数据
      let hiddenCheckedList = this.$getStorage(this.hiddenString);
      this.checkedList = [];
      if (hiddenCheckedList) {
        let array = hiddenCheckedList;
        for (let index = 0; index < array.length; index++) {
          this.checkedList.push(array[index]);
        }
      } else {
        let array = this.tableLabel;
        for (let index = 0; index < array.length; index++) {
          if (array[index].show) {
            this.checkedList.push(array[index].param);
          }
        }
      }
      //样式判断
      this.checkAll = this.checkedList.length === this.tableLabel.length;
      this.isIndeterminate =
        this.checkedList.length > 0 &&
        this.checkedList.length < this.tableLabel.length;
    },
    /** 全选/取消全选列，保存并通知父组件 */
    handleCheckAllChange(value) {
      if (value) {
        this.checkedList = [];
        this.tableLabel.forEach(element => {
          this.checkedList.push(element.param);
        });
      } else {
        this.checkedList = [];
      }
      this.isIndeterminate = false;
      this.$setStorage(this.hiddenString, this.checkedList);
      this.$emit("handleCheckedChangelist", this.checkedList);
    },
    /** 勾选列变化时保存选中列并通知父组件 */
    handleCheckedChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.tableLabel.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.tableLabel.length;
      this.$removeStorage(this.hiddenString);
      this.$setStorage(this.hiddenString, value);
      this.$emit("handleCheckedChangelist", value);
    }
  }
};
</script>